export default {
  heading: 'Bugsweeper, но типа на русском',
  difficulty: 'Сложность',
  easyDifficulty: 'Легко',
  mediumDifficulty: 'Средне',
  expertDifficulty: 'Эксперт',
  audioSettings: 'Настройки звука',
  soundVolume: 'Звук',
  musicVolume: 'Музыка',
  playBtn: 'Играть',
  mineTheme: 'Вид мин',
  languageSettings: 'Язык',
  keybinds: 'Управление',
  keybindUp: 'Вверх - Стрелка Вверх ⬆',
  keybindDown: 'Вниз - Стрелка Вниз ⬇',
  keybindLeft: 'Влево - Стрелка Влево ⬅',
  keybindRight: 'Вправо - Стрелка Вправо ➡',
  keybindNewGame: 'Новая Игра - N',
  score: 'Рекорды',
  time: 'Время',
  back: 'Назад',
};
